import React from 'react';
import {Redirect, Route, Switch,} from 'react-router';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Clients from './clients';
import Members from './members';
import Statistics from './statistics';
import History from './history';
import {getMemberRole} from '../../../../utils/General';
import config from 'config';

const styles = {
    settingsSectionWrapper: {
        height: '100%',
        zIndex: 0,
    },
};

const commonStyles = {
    /*
     * The page's own inset is the only one now - see --ds-page-inset. This used
     * to be a white card with a 30px margin and 40/60 padding inside it, which
     * on a white page is an invisible box that pushes the content a hundred
     * pixels off the panel. What is left here is what the element actually does:
     * it scrolls.
     */
    wrapper: {
        overflow: 'auto',
        maxHeight: 'calc(100vh - 100px)'
    },
    title: {
        color: '#3D568F',
        fontSize: '22px',
        fontWeight: 600,
        marginBottom: '45px',
    },
    smallTitle: {
        fontSize: '16px',
        marginBottom: '10px',
        marginTop: '12px',
        fontWeight: 100,
        color: '#09183A',
    },
};

const Index = (props) => {
    const {
        match, user, company, addNotification,
    } = props;
    const defaultProps = {
        user,
        company,
        addNotification,
        commonStyles,
    };

    const role = getMemberRole(user).id;
    const {tariff} = company
    const {features} = company.tariff;

    return (
        <div className="management un-selectable" style={{height: '100%'}}>
            <div className="settings-section-wrapper" style={styles.settingsSectionWrapper}>
                <Switch>
                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial) && (
                            <Route path={`${match.url}/clients`}
                                   render={routeProps => <Clients {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.USER_MANAGEMENT)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/members`}
                                   render={routeProps => <Members {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.STATISTICS)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/statistics`} render={routeProps =>
                                <Statistics {...routeProps} {...defaultProps} />}/>)
                    }

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.HISTORY)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/history`}
                                   render={routeProps => <History {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin) && (
                        <Route path={`${match.url}/`} render={() => (<Redirect to={`${match.url}/company`}/>)}/>
                    )}

                </Switch>
            </div>
        </div>
    );
};

Index.propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};


export default Radium(Index);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/index.jsx